<template>
    <ToastComponent ref="toast" />
    <GeneralMetadataComponent @show-toast="showToast" @toggle-menu="toggleMenu" :isSidebarMenuOpen="isSidebarMenuOpen"
        @logout="logout" :profile-picture="profilePicture" :email="email" :userName="name" :subscription="subscription"
        :ispago="true" />
    <div id="pago-exitoso">
        <div class="pago-exitoso-top">

            <h1>¡Muchas gracias!</h1>
            <p>🧑🏽‍🤝‍🧑🏽 ChatPTS es un esfuerzo colectivo y militante del PTS y La Izquierda Diario</p>
            <p>🫂 Solo puede gestionarse con personas como vos</p>
            <p>💲 No recibimos financiación de ningún tipo</p>
        </div>
        <div class="o">- ó -</div>
        <div class="pago-exitoso-bottom">
            <button class="secondary" v-if="!showEmailInput" @click="showEmailInput = true">YA PAGUÉ MI
                SUSCRIPCIÓN</button>
            <template v-else>
                <h1>Ya pagué mi suscripción</h1>
                <p>👉🏽 Si ya hiciste el pago a tu suscripción mensual a través de MercadoPago y aún no está asociado a
                    tu
                    usuario, por favor, completá tus datos abajo.</p>
                <div class="form">
                    <label for="email">Ingresá el mail de la cuenta de MercadoPago que usaste, o el mail que pusiste al
                        momento
                        del pago en MercadoPago y el número de comprobante de pago. Podés encontrarlo como "número de
                        operación" en el comprobante.</label>
                    <div class="inputs">
                        <input type="email" id="email" v-model="mercadopago_email" @keyup.enter="buscarSuscripcion"
                            placeholder="Email" />
                        <input type="text" id="transaction_id" v-model="transaction_id"
                            placeholder="ID de la transacción de MercadoPago" />
                    </div>
                    <button @click="buscarSuscripcion">BUSCAR SUSCRIPCIÓN</button>
                </div>
                <p>En caso de que continúes con algún problema, por favor,&nbsp;<a
                        href="https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit">contactanos</a>
                </p>
            </template>
        </div>
        <div class="o">- ó -</div>
        <div class="pago-exitoso-bottom">
            <RouterLink to="/suscribirse">
                <button>Hacer otro aporte</button>
            </RouterLink>
        </div>
    </div>
    <FooterComponent />
</template>

<script>
import GeneralMetadataComponent from '@/components/GeneralMetadataComponent.vue';
import ToastComponent from '@/components/ToastComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

import axios from 'axios';
axios.defaults.withCredentials = true;

export default {
    name: "ChatComponent",
    props: {
    },
    components: {
        ToastComponent,
        GeneralMetadataComponent,
        FooterComponent
    },
    data() {
        return {
            mercadopago_email: '',
            showEmailInput: false,
            email: '',
            name: '',
            permissions: [],
            profilePicture: '',
            isSidebarMenuOpen: false,
            preapprovalId: null,
            subscription: {},
            transaction_id: '',
        };
    },
    watch: {

    },

    methods: {
        async buscarSuscripcion() {
            // Make request to VUE_APP_BASE_URL + /api/v2/suscripciones/buscar-suscripcion/
            // If status is 200, show success message then redirect to /
            // Else show error message
            try {
                const response = await axios.post(process.env.VUE_APP_BASE_URL + '/api/v2/suscripciones/buscar-suscripcion/', {
                    mercadopago_email: this.mercadopago_email,
                    transaction_id: this.transaction_id,
                });
                if (response.status === 200) {
                    this.showToast('Suscripción encontrada', 'success');
                    this.$router.push({ name: 'main-view' });
                }
            } catch (error) {
                console.error(error);
                const detail = error.response ? error.response.data.detail : 'Error desconocido';
                this.showToast('¡Estamos con mucha demanda! al intentar buscar la suscripción: ' + detail, 'error');
            }
        },
        async getUserData(withToast = true) {
            axios
                .get(process.env.VUE_APP_BASE_URL + '/api/v2/users/me/')
                .then((res) => {
                    // The response data is already parsed as JSON
                    const { email, name, permissions, picture, subscription } = res.data;
                    this.email = email;
                    this.name = name;
                    this.permissions = permissions;
                    this.profilePicture = picture;
                    this.subscription = subscription;

                    if (!subscription || !subscription.valid_until || new Date(subscription.valid_until) < new Date()) {
                        console.log("Suscribite :)");
                    } else {
                        this.$router.push({ name: 'main-view' });
                    }

                })
                .catch((err) => {
                    //IF its 401, redirect to /
                    if (err.response && err.response.status === 401) {
                        this.$router.push({ name: 'main-view' });
                    } else {
                        if (err.response) {
                            // The request was made, and the server responded with a status code outside 2xx
                            console.error('User data request failed:', err.response.data.detail);
                            if (withToast) {
                                this.showToast('Error al obtener tus datos. Por favor, intentá de nuevo. Código de error: "' + err.response.data.detail + '"', 'error');
                            }
                        } else if (err.request) {
                            // The request was made, but no response was received
                            console.error('No response received:', err.request);
                            if (withToast) {
                                this.showToast('Error al obtener tus datos. Por favor, intentá de nuevo. Código de error: "' + err.request + '"', 'error');
                            }
                        } else {
                            // Something happened in setting up the request
                            console.error('Error during user data request:', err.message);
                            if (withToast) {
                                this.showToast('Error al obtener tus datos. Por favor, intentá de nuevo. Código de error: "' + err.message + '"', 'error');
                            }
                        }
                    }
                });
        },
        toggleMenu() {
            this.isSidebarMenuOpen = !this.isSidebarMenuOpen;
        },
        showToast(message, type) {
            this.$refs.toast.showToast(message, type);
        },
        logout() {
            // Make a post request to the logout endpoint
            axios.post(process.env.VUE_APP_BASE_URL + '/api/auth/logout/')
                .then(() => {
                    this.email = '';
                    this.name = '';
                    this.permissions = [];
                    this.profilePicture = '';
                    this.subscription = {};
                    console.log('Logged out');
                    this.showToast('Sesión cerrada. ¡Hasta la próxima!', 'success');
                    setTimeout(() => {
                        this.$router.push({ name: 'main-view' });
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Error logging out:', error);
                    this.showToast('¡Estamos con mucha demanda! al intentar cerrar sesión.', 'error');
                    
                    // Clear local variables even on error for security
                    this.email = '';
                    this.name = '';
                    this.permissions = [];
                    this.profilePicture = '';
                    this.subscription = {};
                });
        },
    },

    async mounted() {
        await this.getUserData(false);
        this.preapprovalId = this.$route.query.preapproval_id;
        // Make request to VUE_APP_BASE_URL + /api/v2/suscripciones/pago-exitoso/
        // If status is 200, show success message then redirect to /
        // Else show error message
        try {
            const response = await axios.post(process.env.VUE_APP_BASE_URL + '/api/v2/suscripciones/pago-exitoso/', {
                preapproval_id: this.preapprovalId
            });
            if (response.status === 200) {
                this.showToast('Pago exitoso', 'success');
                this.$router.push({ name: 'main-view' });
            }
        } catch (error) {
            console.error(error);
            const detail = error.response ? error.response.data.detail : 'Error desconocido';
            this.showToast('¡Estamos con mucha demanda! al intentar procesar el pago: ' + detail, 'error');
        }
    }
};
</script>

<style scoped>
#pago-exitoso {
    background: transparent;
    width: 100vw;
    max-width: 1200px;
    padding: 24px;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.pago-exitoso-top,
.pago-exitoso-bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    background-color: rgba(50, 50, 50, 0.85);
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
    border-radius: 12px;
    padding: 24px;
    width: 100%;
}

.pago-exitoso-top p,
.pago-exitoso-bottom p {
    font-size: 18pt;
    color: #fff;
}


#pago-exitoso h1 {
    font-weight: 500;
    text-align: center;
    margin-bottom: 24px;
    border-radius: 24px;
    color: #a1344e;
    font-size: 28pt;
}

.buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    max-width: 1000px;
}

.mp-button,
button {
    background-color: #a1344e;
    color: #fff;
    padding: 12px 24px;
    border-radius: 12px;
    margin: 12px;
    text-decoration: none;
    font-weight: normal;
    font-size: 18pt;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    border: none;
}

button.secondary {
    background-color: #f0f0f0;
    color: #a1344e;
}

#pago-exitoso h2 {
    font-weight: bold;
    margin-bottom: 24px;
    margin-top: 12px;
}

#pago-exitoso p {
    margin-bottom: 24px;
}

.login-footer-2 {
    padding-top: 24px;
    padding-bottom: 24px;
    color: #f0f0f0;

}

.login-footer-2 nav>* {
    margin: 12px;
}

.form {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
}

.form label {
    color: #fff;
    font-size: 18pt;
    margin-right: 24px;
}

.form input {
    padding: 12px;
    border-radius: 12px;
    border: none;
    font-size: 18pt;
    width: 400px;
    margin-right: 24px;
}

.o {
    color: #fff;
    font-size: 18pt;
    margin-bottom: 24px;
}

.inputs {
    display: flex;
    flex-direction: column;
}

.inputs>* {
    margin-bottom: 12px;
}


/* mobile */
@media (max-width: 768px) {
    .buttons-container {
        flex-direction: column;
    }

    .pago-exitoso-top p,
    .pago-exitoso-bottom p {
        font-size: 13pt;
    }

    .mp-button,
    button {
        width: 100%;
    }

    .form {
        flex-direction: column;
    }

    .form input {
        width: 100%;
        margin-right: 0;
    }

    .form label {
        color: #f0f0f0;
        font-size: 16pt;
        margin-bottom: 12px;
        text-align: center;
    }
}
</style>
